module.exports = __webpack_public_path__ + "img/ic-caret-down.dea3c78e.svg";